import { render, staticRenderFns } from "./DeliverablesTab.vue?vue&type=template&id=fe803356&scoped=true&"
import script from "./DeliverablesTab.vue?vue&type=script&lang=js&"
export * from "./DeliverablesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe803356",
  null
  
)

export default component.exports